import React from "react";
import PropTypes from "prop-types";
import { FileText } from "lucide-react";

import TruncatedWithTooltip from "../../../../../TruncatedWithTooltip";
import { UIButton } from "../../../../../ui";

import "./EventPayrollPaymentProof.scss";

const EventPayrollPaymentProof = ({
  fileName,
  href,
  addProofLabel,
  canAdd,
  disabled,
  onAddProof,
  onViewProof,
}) => {
  if (fileName) {
    return (
      <button
        type="button"
        className="event-payroll-payment-proof"
        onClick={(event) => {
          event.stopPropagation();
          onViewProof?.(fileName, href);
        }}
      >
        <span className="event-payroll-payment-proof__icon-box" aria-hidden>
          <FileText size={20} strokeWidth={1.3} />
        </span>
        <TruncatedWithTooltip title={fileName} tooltipDir="ltr">
          <span
            className="event-payroll-payment-proof__filename text-label-sm"
            dir="ltr"
          >
            {fileName}
          </span>
        </TruncatedWithTooltip>
      </button>
    );
  }

  if (!canAdd) {
    return <span className="MuiDataGrid-cellContent">-</span>;
  }

  return (
    <UIButton
      type="button"
      variant="outline"
      appearance="outline"
      size="small"
      className="event-payroll__add-proof-btn"
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onAddProof?.();
      }}
    >
      {addProofLabel}
    </UIButton>
  );
};

EventPayrollPaymentProof.propTypes = {
  fileName: PropTypes.string,
  href: PropTypes.string,
  addProofLabel: PropTypes.string.isRequired,
  canAdd: PropTypes.bool,
  disabled: PropTypes.bool,
  onAddProof: PropTypes.func,
  onViewProof: PropTypes.func,
};

EventPayrollPaymentProof.defaultProps = {
  fileName: "",
  href: "",
  canAdd: true,
  disabled: false,
  onAddProof: undefined,
  onViewProof: undefined,
};

export default EventPayrollPaymentProof;
